import { Injectable } from '@angular/core';
import { ApiService, GetRequestArguments, PostRequestArguments, Refresh } from './api.service';
import { CacheService } from 'ionic-cache';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class EmploymentService {

  public $employments = new BehaviorSubject([]);
  public $currentNrHolidays = new BehaviorSubject(0);
  public $editing = new BehaviorSubject([]);

  private url = 'employment';
  private groupKey = 'employment';
  constructor(private api: ApiService,
              private cache: CacheService,
              private formBuilder: UntypedFormBuilder) {

  }

  public load(refresh: Refresh = 'expired') {
    const args = new GetRequestArguments({
      url: [this.url],
      cacheGroup: this.groupKey,
      refresh,
    });
    const request = this.api.cachedGetRequest(args);
    request.subscribe(employments => {
      this.api.updateObservable(employments, this.$employments);
    });
    return request;
  }

  public loadUser(refresh: Refresh = 'expired') {
    const args = new GetRequestArguments({
      url: [this.url, 'user'],
      cacheGroup: this.groupKey,
      refresh,
    });
    const request = this.api.cachedGetRequest(args);
    request.subscribe(employments => {
      this.api.updateObservable(employments, this.$employments);
    });
    return request;
  }

  public post(form) {
    const data = this.api.createFormData(form.value);
    const args = new PostRequestArguments({
      url: [this.url],
      object: data
    });
    const call = this.api.postRequest(args);
    return call;
  }

  public fillForm(employment, form) {
    form.controls.additional_data.patchValue(employment.additional_data);
    form.controls.created_at.patchValue(employment.created_at);
    form.controls.end_date.patchValue(employment.end_date);
    form.controls.percentage.patchValue(employment.percentage);
    form.controls.position.patchValue(employment.position);
    form.controls.start_date.patchValue(employment.start_date);
    form.controls.updated_at.patchValue(employment.updated_at);
    form.controls.user.patchValue(employment.user);
    form.controls.user_id.patchValue(employment.user_id);
    form.controls.version.patchValue(employment.version);
    form.controls.weekly_hours.patchValue(employment.weekly_hours);
    form.controls.iban.patchValue(employment.iban);
  }

  public createForm() {
    return this.formBuilder.group({
      additional_data: [undefined, []],
      created_at: [undefined, []],
      end_date: [undefined, []],
      percentage: [undefined, [Validators.required]],
      position: [undefined, [Validators.required]],
      start_date: [undefined, []],
      updated_at: [undefined, []],
      user: [undefined, []],
      user_id: [undefined, []],
      version: [undefined, []],
      weekly_hours: [undefined, []],
      iban: [undefined, []]
    });
  }

  delete(form) {

    // const data = this.api.createFormData(form);
    const index = this.$editing.value.findIndex(e => e.version === form.version);
    this.$editing.value.splice(index, 1);

    const args = new PostRequestArguments({
      url: [this.url, form.user_id],
      object: form.version
    });

    const request = this.api.deleteRequest(args);
    request.subscribe(res => {});
    return request;
  }

  loadHolidays(userId: number, refresh: Refresh = 'all') {
    const args = new GetRequestArguments({
      url: ['nr_holidays', userId],
      cacheGroup: this.groupKey,
      refresh,
    });
    const request = this.api.cachedGetRequest(args);
    request.subscribe(holidays => {
      if (holidays?.id) {
        this.api.updateObservable(Number(holidays?.count), this.$currentNrHolidays);
      } else {
        this.api.updateObservable(0, this.$currentNrHolidays);
      }
    });
    return request;
  }

  postHolidays(nr, user_id) {
    const data = this.api.createFormData({
      user_id: user_id,
      days: nr,
    });
    const args = new PostRequestArguments({
      url: ['nr_holidays'],
      object: data
    });
    const call = this.api.postRequest(args);
    call.subscribe(res => { });
    return call;
  }
}
